import { useCallback } from 'react';
import { useLoading } from '../contexts/LoadingContext';
import { useToast } from '../contexts/ToastContext';

interface ApiCallOptions {
  loadingKey?: string;
  loadingMessage?: string;
  overlay?: boolean;
  successMessage?: string;
  errorMessage?: string;
  showToast?: boolean;
}

export function useApiCall() {
  const { setLoading, clearLoading } = useLoading();
  const { success, error: showError } = useToast();

  const apiCall = useCallback(async function<T>(
    apiFunction: () => Promise<T>,
    options: ApiCallOptions = {}
  ): Promise<T | null> {
    const {
      loadingKey = 'default',
      loadingMessage = 'Yükleniyor...',
      overlay = false,
      successMessage,
      errorMessage = 'İşlem sırasında bir hata oluştu.',
      showToast = true
    } = options;

    try {
      // Loading başlat
      setLoading(loadingKey, true, loadingMessage, overlay);

      // API çağrısını yap
      const result = await apiFunction();

      // Başarı mesajı göster
      if (successMessage && showToast) {
        success('Başarılı', successMessage);
      }

      return result;
    } catch (error) {
      console.error('API call error:', error);
      
      // Hata mesajı göster
      if (showToast) {
        showError('Hata', errorMessage);
      }
      
      return null;
    } finally {
      // Loading'i temizle
      clearLoading(loadingKey);
    }
  }, [setLoading, clearLoading, success, showError]);

  return { apiCall };
}